var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFileSize(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.6667 8.33333C16.2064 8.33333 15.8333 7.96024 15.8333 7.5V5.34519L5.34519 15.8333H7.5C7.96024 15.8333 8.33333 16.2064 8.33333 16.6667C8.33333 17.1269 7.96024 17.5 7.5 17.5H4.16667C3.24619 17.5 2.5 16.7538 2.5 15.8333V12.5C2.5 12.0398 2.8731 11.6667 3.33333 11.6667C3.79357 11.6667 4.16667 12.0398 4.16667 12.5V14.6548L14.6548 4.16667L12.5 4.16667C12.0398 4.16667 11.6667 3.79357 11.6667 3.33333C11.6667 2.8731 12.0398 2.5 12.5 2.5H15.8333C16.7538 2.5 17.5 3.24619 17.5 4.16667V7.5C17.5 7.96024 17.1269 8.33333 16.6667 8.33333Z",
    fill: "#6F767E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.5 4.16667C2.5 3.24619 3.24619 2.5 4.16667 2.5H7.5C7.96024 2.5 8.33333 2.8731 8.33333 3.33333C8.33333 3.79357 7.96024 4.16667 7.5 4.16667H4.16667V7.5C4.16667 7.96024 3.79357 8.33333 3.33333 8.33333C2.8731 8.33333 2.5 7.96024 2.5 7.5V4.16667Z",
    fill: "#6F767E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.5 15.8333C17.5 16.7538 16.7538 17.5 15.8333 17.5H12.5C12.0398 17.5 11.6667 17.1269 11.6667 16.6667C11.6667 16.2064 12.0398 15.8333 12.5 15.8333H15.8333V12.5C15.8333 12.0398 16.2064 11.6667 16.6667 11.6667C17.1269 11.6667 17.5 12.0398 17.5 12.5V15.8333Z",
    fill: "#6F767E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileSize);
export default __webpack_public_path__ + "static/media/fileSize.daeceb5e7ac2bff37ee416df7fa170b5.svg";
export { ForwardRef as ReactComponent };